module.exports = __webpack_public_path__ + "static/img/partner-ht.3481026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ht.png
// module id = RC9D
// module chunks = 34